import { Pipe, PipeTransform } from '@angular/core';

const paymentMethods = new Map([
    ['A', 'EFECTIVO'],
    ['B', 'VISA'],
    ['C', 'VISANET'], 
    ['D', 'AMERICAN EXPRESS'],
    ['E', 'MASTER'],
    ['F', 'CARSA'],
    ['G', 'CURACAO'],
    ['H', 'DINNER'],
    ['I', 'METRO'],
    ['J', 'RIPLEY'],
    ['K', 'TOPY TOP'],
    ['L', 'CMR'],
    ['M', 'MAESTRO'],
    ['N', 'DEBITO AUTOMÁTICO'],
    ['O', 'CHEQUE'],
    ['P', 'PROCESOS'],
    ['Q', 'ARCHIVO CONTINENTAL'],
    ['R', 'ARCHIVO AMERICAN EXPRESS'],
    ['S', 'ARCHIVO CMR'],
    ['T', 'ARCHIVO TELEFONICA'],
    ['U', 'DEPOSITOS BANCO'],
    ['V', 'ARCHIVO BANCO CREDITO'],
    ['W', 'Financiero'],
    ['X', 'Interbank'],
    ['Y', 'Caja Municipal'],
    ['Z2', 'INTERSOCIO']
]);

@Pipe({
    name: 'wayPay',
})
export class WayPayPipe implements PipeTransform {
    transform(value: string): string | null {
        return paymentMethods.get(value) || null;
    }
}
